
import router from '@/router'
import Constains from '@/components/Constains';
import { StopOutlined } from '@ant-design/icons-vue';
import type { SelectProps } from 'ant-design-vue';
import { defineComponent, reactive, onMounted,ref } from 'vue';
import axios from 'axios';
import { useCookies } from 'vue3-cookies';

interface FormState {
  shopcode: string;
  code: string;
  password: string;
  //remember: boolean;
}
export default defineComponent({
  components: {
    StopOutlined,
  },
  setup() {
    let spinning = reactive({loading:true});
    const visible = ref<boolean>(false)
    const cookies  = useCookies();
    const pharmacyMode = ref(false)
    const formState = reactive<FormState>({
      shopcode: '',
      code: '',
      password: '',
      //remember: true,
    });
    const pharmacylist:any = ref([])
    const options = ref<SelectProps['options']>([]);
    const handleChange = (value: string) => {
      console.log(`selected ${value}`);
    };

    const shoplist:any = ref([])
    const shopcode:any = ref()

    const filterOption = (input: string, option: any) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };
    onMounted(async () => {
      const res = await axios.post(Constains.baseURL+'/listshop',JSON.stringify({}));
      if(res.status == 200){
        const data = res.data
          data.forEach((shop:any) => {
            shoplist.value.push(
              {
                value:shop.code,
                label:shop.name,
                detail:shop.detail == '' ? {} : JSON.parse(shop.detail)
              }
            )
          });
          shoplist.value.sort((a:any,b:any)=>{
            return a.detail.sort - b.detail.sort;
          })
      }
      /*
      const json = {
        shopcode:Constains.shopcode
      }
      const res = await axios.post(Constains.baseURL+'/listpharmacies',JSON.stringify(json));
      console.log(res.status,res.data);
      if(res.status == 200){
        for(let i = 0; i < res.data.length;i++){
          var ca = res.data[i];
          //options.value?.push({label:ca.name,value:ca.address})
          pharmacylist.value.push({
            label:ca.name,
            value:ca.code
          })
        }
      }*/
    })
    const onFinish = async(values: any) => {
      console.log('Success:', values);
      var shopcode = formState.shopcode;
      var usercode = formState.code;
      var password = formState.password;
      const json = {
            'shopcode':shopcode,
            'user':usercode,
            'code':usercode,
            'password':password,
          }
      visible.value = false;

      try{
          const res = await axios.post(Constains.managementURL+'/api/admin/login',JSON.stringify(json),
            {headers:{'Content-Type': 'application/json', }});
          console.log('states:'+res.status);
          console.log('response:'+JSON.stringify(res.data));

          if(res.status == 200){
            const token = res.data['token'];
            cookies.cookies.set('token',token ,);
            cookies.cookies.set('shopcode',shopcode ,);
            cookies.cookies.set('usercode',usercode ,);
            /*
            if(formState.remember){
              //cookieに1ヶ月保存
              cookies.cookies.set('token',token ,'30d');
              cookies.cookies.remove('pharmacy');
            } else {
              //cookieの保存期限をnullにすれば閉じれば消せる
              cookies.cookies.set('token',token ,);
              cookies.cookies.remove('pharmacy');
            }
            */

            router.push('/commodity');
          } else {
            visible.value = true;
          }
        } catch(e){
          console.log(e)
          visible.value = true;
        }
      
    };

    const onFinishFailed = (errorInfo: any) => {
      console.log('Failed:', errorInfo);
    };
    return {
      spinning,
      cookies,
      formState,
      onMounted,
      onFinish,
      onFinishFailed,
      //filterOption,
      handleChange,
      options,
      visible,
      pharmacyMode,
      pharmacylist,
      shoplist,
      shopcode,
    };
  },
});
